import React from 'react'
import FooterBottom from './FooterBottom'
import FooterTop from './FooterTop'

const Footer = () => {
  return (
    <div>
        <FooterTop/>
        <FooterBottom/>
    </div>
  )
}

export default Footer